import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";
import { ActiveRangeBarChartComponent } from "./activeRangeBarChart/active-range-bar-chart.component";
import { BarChartComponent } from "./barChart/barChart.component";
import { DriverActivityGanttComponent } from "./ganttChart/ganttChart.component";
import { HorizontalBarChartComponent } from "./horizontalBarChart/horizontalBarChart.component";
import { ListogramComponent } from "./listogram/listogram.component";
import { RagRangeBarChartComponent } from "./ragRangeBarChart/ragRangeBarChart.component";

angular
    .module("app.visualisations", [])
    .component("ragRangeBarChart", new RagRangeBarChartComponent())
    .component("ganttChart", new DriverActivityGanttComponent())
    .component("barChart", new BarChartComponent())
    .component("horizontalBarChart", new HorizontalBarChartComponent())
    .component("listogram", new ListogramComponent())

    //.directive("gauge", downgradeComponent({ component: GaugeComponent }))
    .directive("activeRangeBarChart", downgradeComponent({ component: ActiveRangeBarChartComponent }))
    ;
